import { render, staticRenderFns } from "./LivePhoto.vue?vue&type=template&id=84f0bd10&scoped=true"
import script from "./LivePhoto.vue?vue&type=script&lang=ts"
export * from "./LivePhoto.vue?vue&type=script&lang=ts"
import style0 from "./LivePhoto.vue?vue&type=style&index=0&id=84f0bd10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f0bd10",
  null
  
)

export default component.exports